import React from 'react'

export const TickIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='10.641'
		height='8.572'
		className='tickicon-svg'
		viewBox='0 0 10.641 8.572'>
		<path
			id='tick-sign'
			d='M9.015,33.286l-5.321,5.32L1.626,36.538,0,38.164l3.695,3.694,6.947-6.946Z'
			transform='translate(0 -33.286)'
			fill='#7a719b'
		/>
	</svg>
)

export const PackageDowngradeIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='18.978'
		height='18.749'
		className='downgradeicon-svg'
		viewBox='0 0 18.978 18.749'>
		<g id='fast-forward' transform='translate(18.978) rotate(90)'>
			<path
				id='Path_3369'
				data-name='Path 3369'
				d='M11.318,11.319l-6.9,6.9A2.587,2.587,0,0,1,.758,14.56l5.07-5.072L.758,4.418A2.588,2.588,0,0,1,4.417.757l6.9,6.9A2.592,2.592,0,0,1,11.318,11.319Z'
				transform='translate(6.674 0)'
				fill='#fff'
			/>
			<path
				id='Path_3370'
				data-name='Path 3370'
				d='M6.815,6.815,2.66,10.97a1.558,1.558,0,1,1-2.2-2.2L3.509,5.713.457,2.66a1.558,1.558,0,0,1,2.2-2.2L6.815,4.611A1.56,1.56,0,0,1,6.815,6.815Z'
				transform='translate(0 3.775)'
				fill='#fff'
			/>
		</g>
	</svg>
)

export const ContactUsIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='25.601'
		height='24.001'
		viewBox='0 0 25.601 24.001'>
		<g id='chat_1_' data-name='chat (1)' transform='translate(0 -16)'>
			<g id='Group_4968' data-name='Group 4968' transform='translate(0 16)'>
				<path
					id='Path_3584'
					data-name='Path 3584'
					d='M12.75,16C5.72,16,0,21.047,0,27.25a10.484,10.484,0,0,0,2.925,7.173,4.561,4.561,0,0,1-1.2,4.3A.751.751,0,0,0,2.25,40a8.27,8.27,0,0,0,5.728-2.314,14.143,14.143,0,0,0,4.772.814c7.031,0,12.85-5.047,12.85-11.25S19.781,16,12.75,16ZM6.85,29.5A2.25,2.25,0,1,1,9.1,27.25,2.253,2.253,0,0,1,6.85,29.5Zm6,0a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,12.85,29.5Zm6,0a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,18.85,29.5Z'
					transform='translate(0 -16)'
					fill='#fff'
				/>
			</g>
		</g>
	</svg>
)

export const PackageUpgradeIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='45.973'
		height='45.418'
		viewBox='0 0 45.973 45.418'>
		<defs>
			<linearGradient
				id='linear-gradient'
				x1='-1.08'
				y1='-0.125'
				x2='1.293'
				y2='-0.118'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stop-color='#3b2a82' />
				<stop offset='1' stop-color='#ff3067' />
			</linearGradient>
		</defs>
		<g
			id='Group_4930'
			data-name='Group 4930'
			transform='translate(-1070.001 -436.666)'>
			<g id='fast-forward' transform='translate(1022.021 486.486) rotate(-90)'>
				<path
					id='Path_3369'
					data-name='Path 3369'
					d='M251.417,66.533,234.7,49.817a6.268,6.268,0,1,0-8.864,8.864l12.283,12.287L225.837,83.25a6.269,6.269,0,0,0,8.864,8.868L251.417,75.4A6.278,6.278,0,0,0,251.417,66.533Z'
					transform='translate(-203.43 0)'
					fill='url(#linear-gradient)'
				/>
				<path
					id='Path_3370'
					data-name='Path 3370'
					d='M16.509,59.151,6.443,49.086a3.774,3.774,0,0,0-5.337,5.337l7.4,7.4-7.4,7.4a3.775,3.775,0,0,0,5.337,5.34L16.509,64.491A3.78,3.78,0,0,0,16.509,59.151Z'
					transform='translate(4.402 9.146)'
					fill='url(#linear-gradient)'
				/>
			</g>
		</g>
	</svg>
)

export const LockIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='11.432'
		height='15.242'
		className='lockicon-svg'
		viewBox='0 0 11.432 15.242'>
		<path
			id='_1828471'
			data-name='1828471'
			d='M10,5.716H9.526V3.811a3.811,3.811,0,0,0-7.621,0V5.716H1.429A1.431,1.431,0,0,0,0,7.145v6.668a1.431,1.431,0,0,0,1.429,1.429H10a1.431,1.431,0,0,0,1.429-1.429V7.145A1.431,1.431,0,0,0,10,5.716ZM3.175,3.811a2.54,2.54,0,0,1,5.081,0V5.716H3.175Zm0,0'
			fill='#7a719b'
		/>
	</svg>
)
